<script>
	import {locale} from 'svelte-i18n';
	import ContactPl from './dict/pl/ContactPl.svelte';
	import ContactEn from './dict/en/ContactEn.svelte';
</script>

{#if $locale == 'pl'}
	<ContactPl/>
{:else}
	<ContactEn/>
{/if}

